import { useState, useCallback, useEffect } from "react";
import { useApi } from "providers/ApiProvider";
import { getOptions } from "hooks/useFormSelect";
import { DropdownList as _DropdownList } from "components/DropdownList";
import { styled } from "@mui/material";

export const DropdownList = styled(_DropdownList)(
  ({ theme }) => `
  height: 34px;
  
  input {
    padding-left: 20px !important;
    font-size: 14px !important;
    &::placeholder {
      color: ${theme.palette.bluegrey["600"]};
      opacity: 1;
    }
  }
  .MuiOutlinedInput-root {
    border-radius: 4px !important;
    font-size: 14px !important;
  }
  fieldset {
    border-color: ${theme.palette.layout.line};
  }
`
);

type DoctorSelectProps = {
  value: any;
  onChange: (value: any) => void;
};

export function DoctorSelect({ value, onChange }: DoctorSelectProps) {
  const { userApi } = useApi();
  const [doctors, setDoctors] = useState([]);

  const loadDoctors = useCallback(async () => {
    const res = await userApi.getDuty("의사");
    const payload = await res.data;
    payload.data && setDoctors(payload.data);
  }, [userApi]);

  useEffect(() => {
    loadDoctors();
  }, [loadDoctors]);

  return (
    <>
      <DropdownList
        options={getOptions(doctors ?? []).map((item: any) => {
          item.label = item.name;
          return item;
        })}
        value={doctors.find((f: any) => f.id === value?.id)}
        onChange={(v) => {
          onChange(v ?? null);
        }}
        placeholder="의사를 선택하세요."
      />
    </>
  );
}
